import { ModuleModel } from '../../module.model.interface';
import { ProfileModel } from '../../profile/model/profile.model';

export class CaseParticipantDescriptor implements ModuleModel {
  public discriminator = 'CaseParticipantDescriptor';

  public id: string;
  public caseId: string;
  public profileId: string;
  public externalCommunicationAllowed: boolean;
  public href: string;
  public modified: Date;
  public deleted: Date;

  public profileDetail: ProfileModel;
  public profileFullName: string;

  constructor(options?: {
    id: string;
    caseId: string;
    profileId: string;
    externalCommunicationAllowed: boolean;
    href: string;
    modified: Date;
    deleted: Date;
  }) {

    if (options) {
      this.id = options.id;
      this.caseId = options.caseId;
      this.profileId = options.profileId;
      this.externalCommunicationAllowed = options.externalCommunicationAllowed;
      this.href = options.href;
      this.modified = options.modified;
      this.deleted = options.deleted;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/case.participant/model/case.participant.ts